<template>
  <div>
    <!-- step 1 - select sport -->
    <div class="field">
      <label class="label">Sport</label>
      <b-select placeholder="Select a sport" expanded v-model="selectedSport">
        <option v-for="sport in sports" :value="sport" :key="sport">{{ sport }}</option>
      </b-select>
    </div>

    <!-- step 2 - select feed -->
    <div v-if="feeds" class="field">
      <label class="label">Tournament</label>
      <b-select placeholder="Select a tournament" expanded v-model="selectedTournament">
        <option
          v-for="tournament in feeds"
          :value="tournament.id"
          :key="tournament.id"
        >{{ tournament.name }}</option>
      </b-select>
    </div>

    <!-- step 3 - enter round name -->
    <div v-if="selectedTournament && selectedSport" class="field">
      <label class="label">Round Name</label>
      <div class="control">
        <input class="input" type="text" v-model="roundName" placeholder="Matchday 20 of 26">
      </div>
    </div>

    <!-- step 4 - selection -->
    <div v-if="selectedTournament && selectedSport && roundName && fixtures">
      <div class="field">
        <label class="label">Select fixtures to apply round name to</label>
      </div>
      <table class="table is-fullwidth is-bordered">
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Date</th>
            <th>Location</th>
            <th>Round Name</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="fixture.id" v-for="fixture in fixtures">
            <td>
              <b-checkbox v-model="fixture.selected" type="is-success"></b-checkbox>
            </td>
            <td>{{ fixture.name }}</td>
            <td>{{ fixture.starts_at.substring(0, 10) }}</td>
            <td>{{ fixture.location }}</td>
            <td>{{ fixture.round_name }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- step 5 - saving -->
    <div
      style="margin-top:10px;"
      class="field"
      v-if="selectedTournament && selectedSport && roundName && fixtures && selection"
    >
      <button class="button is-primary" @click="saveChanges">Save Changes</button>
    </div>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
import {
  GET_FEEDS,
  GET_FEED_FIXTURES,
  UPDATE_ROUND_NAMES
} from "@/store/actions";
import Loading from "@/components/Loading";

export default {
  name: "Rounds",
  components: {
    Loading
  },
  data() {
    return {
      selectedSport: "Football, Rugby & Cricket",
      selectedTournament: null,
      roundName: null,
      sports: ["Football, Rugby & Cricket", "Football", "Rugby", "Cricket"],
      loading: false
    };
  },
  computed: {
    data() {
      return this.$store.state.feeds.data;
    },
    feeds() {
      const { data, selectedSport } = this;

      if (!data) {
        return null;
      }

      return selectedSport === "Football, Rugby & Cricket"
        ? [...data].filter(x => x.enabled)
        : [...data].filter(x => x.enabled && x.type === selectedSport);
    },
    fixtures() {
      return this.$store.state.feed.fixtures;
    },
    selection() {
      return this.fixtures.filter(x => x.selected === true);
    }
  },
  watch: {
    selectedSport() {
      this.selectedTournament = null;
    },
    selectedTournament() {
      this.roundName = null;
      this.getFixtures();
    }
  },
  mounted() {
    const { data } = this;

    if (!data || data.length <= 0) {
      this.$store.dispatch(GET_FEEDS);
    }
  },
  methods: {
    getFixtures() {
      this.loading = true;
      this.$store
        .dispatch(GET_FEED_FIXTURES, {
          feedId: this.selectedTournament,
          status: "Coming Up"
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveChanges() {
      const ids = this.selection.map(x => x.id);
      this.loading = true;
      this.$store
        .dispatch(UPDATE_ROUND_NAMES, { ids: ids, round_name: this.roundName })
        .then(res => {
          this.getFixtures();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>